<template>
  <div class="main">
    <img class="img" src="../assets/images/empty.png" alt="unlucky" />
    <div class="text">您的账号异常，暂时无法参与活动</div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$emit('reportEvent', {
      event: 'risk_page_expo'
    });
  }
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    width: 360px;
    height: 262px;
    margin-bottom: 70px;
  }

  .text {
    font-size: 30px;
    color: #8c8c8c;
  }
}
</style>
